module.exports = __webpack_public_path__ + "img/logo-balamboo.ee32ea8b.png";